import React from 'react';
import { Modal, Button, Divider, Image, Tabs, Col, Row, Avatar, List } from 'antd';
import { PictureOutlined, AudioOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { global_var } from "../../services/cs-lab-config";
import { useState, useEffect } from "react";  
import { getIdeProjectTypeMetaData, formatDate } from "../utils/util-functions";
import  userLogo from "../../assets/logos/remarks icon.svg";

const ModalComponent = ({ isOpen, handleCancel, assignmentObj, remarksData, activeTab, evaluationRemarks,evaluationStatus }) => {
const [showImage, setShowImage] = useState(false);
const [showVideo, setShowVideo] = useState(false);
const [videoModalVisible, setVideoModalVisible] = useState(false);
const [selectedVideo, setSelectedVideo] = useState('');
const [showAudio, setShowAudio] = useState(false);
const [imagePreview, setImagePreview] = useState(null);
const [audioPreview, setAudioPreview] = useState(null);
const [videoPreview, setVideoPreview] = useState(null);
const [projectLogo, setProjectLogo] = useState(null);
const [tabKey, setTabKey] = useState(activeTab);
const { TabPane } = Tabs;

  useEffect(() => {
    if (assignmentObj) {
      const projectMetaData = getIdeProjectTypeMetaData(
        assignmentObj.projectType
      );
      setProjectLogo(projectMetaData.logo)
      
      let questionImage = [];
      let questionAudio = [];
      let questionVideo = [];
            if (assignmentObj.elements) {
              assignmentObj.elements
                    .forEach((item) => {
                        if (item.value && item.value.question) {
                            // Loop through the "question" array
                            item.value.question.forEach((questionItem) => {
                                if (questionItem.type === "image") {
                                    const imageUrl  = global_var.CLOUD_ASSET_STORAGE_URL + '/' + questionItem.question;
                                    questionImage.push(imageUrl)
                                }
                                if (questionItem.type === "audio") {
                                    // Store multiple image items
                                    const audioUrl  = global_var.CLOUD_ASSET_STORAGE_URL + '/' + questionItem.question;
                                    questionAudio.push(audioUrl)
                                }
                                if (questionItem.type === "video") {
                                  let videoUrl;
                                  if (questionItem.question.includes("http://") || questionItem.question.includes("https://")) {
                                      videoUrl = questionItem.question; // New condition: take the URL directly
                                  } else {
                                      videoUrl = global_var.CLOUD_ASSET_STORAGE_URL + '/' + questionItem.question; // Old condition: prepend the base URL
                                  }
                                  questionVideo.push(videoUrl);
                                }
                            });
                        }
                    });
            }
            setImagePreview(questionImage);
            setAudioPreview(questionAudio);
            setVideoPreview(questionVideo);
    }
  }, [assignmentObj]);

  const handleViewImages = () => {
    setShowImage(true);
  };
  const handleListenAudio = () => {
    setShowAudio(true);
  };
  const handleViewVideo = () => {
    setShowVideo(true);
  };

  const handleOpenVideoModal = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setVideoModalVisible(true);
  };

  const handleTabChange = (key) => {
    setTabKey(key);  };

  return (
    <Modal
        width={700}
        open={isOpen}
        onCancel={handleCancel}
        footer={null}
        style={{ marginRight: 0, marginTop: '-100px' }}
        >
      <Tabs defaultActiveKey={activeTab}  activeKey={tabKey} onChange={handleTabChange} type="card" className="custom-tabs"
      >
      {assignmentObj && Object.keys(assignmentObj).length > 0 && (
        <TabPane tab="Question" key="1" >
        <>
        <Row>
        <Col className='col-1'>
        <Avatar
          src={projectLogo}        
        />
        </Col>
        <Col className='col-10'>
          {assignmentObj ? (
            <div>
              <h5 style={{ marginBottom: '0px' }}>{assignmentObj.title}</h5>
              <p className='pb-0' style={{ fontSize: '12px'}}>{assignmentObj.projectType}</p>
              {assignmentObj.totalMark ? (
                    <p className="pt-0" style={{ fontSize: '12px' }}>
                      {assignmentObj.totalMark} Marks
                    </p>
                  ) : null}
            </div>
          ) : null}
        </Col>
        </Row>
        {assignmentObj ? (
        <div dangerouslySetInnerHTML={{ __html: assignmentObj.elements[1].value.ques }} />
        ) : null}  
          <Divider />
          <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'flex-start' }}>
            {imagePreview && imagePreview.length > 0 && (
              <div>
              <Button onClick={handleViewImages} style={{ backgroundColor: '#ffffff', borderColor: '#E96358', color: '#E96358' }}>
                <PictureOutlined /> View Image Attachments
              </Button>
              <div style={{ marginTop: '10px' }}>
                <Image.PreviewGroup
                  preview={{
                    onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                  }}
                >
                  {showImage &&
                    imagePreview.map((image, index) => (
                      <Image
                        key={image}
                        src={image}
                        alt={`Question ${index + 1}`}
                        width={200}
                        height={200}
                        style={{ border: '8px solid #f0eded' }}
                      />
                    ))}
                </Image.PreviewGroup>
              </div>
            </div>            
            )}
            {audioPreview && audioPreview.length > 0 && (
              <div>
                <Button onClick={handleListenAudio} style={{ backgroundColor: '#ffffff', borderColor: '#E96358', color: '#E96358' }}>
                  <AudioOutlined /> Listen Audio Attachments
                </Button>
                {showAudio && audioPreview.map((audio, index) => (
                  <audio key={index} controls>
                    <source src={audio} type="audio/mp3" />
                  </audio>
                 ))}
              </div>
            )}

            {videoPreview && videoPreview.length > 0 && (
              <div>
                <Button
                  onClick={handleViewVideo}
                  style={{
                    backgroundColor: '#ffffff',
                    borderColor: '#E96358',
                    color: '#E96358',
                    marginTop: 10,
                    paddingRight: 20,
                  }}
                >
                  <VideoCameraOutlined /> View Video Attachments
                </Button>

                <div style={{ marginTop: '10px' }}>
                  {showVideo &&
                    videoPreview.map((video, index) => (
                      <div
                        key={index}
                        style={{
                          position: 'relative',
                          display: 'inline-block',
                          margin: '10px',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleOpenVideoModal(video)}
                      >
                        {/* Thumbnail-style preview */}
                        <video
                          width={300}
                          height={200}
                          style={{ border: '6px solid #f0eded', objectFit: 'cover' }}
                          muted
                        >
                          <source src={video} type="video/mp4" />
                        </video>

                        {/* Overlay with play icon */}
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0,0,0,0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '50px',
                            borderRadius: '4px',
                          }}
                        >
                          ▶
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

          <Modal
            title="Video"
            centered
            visible={videoModalVisible}
            onCancel={() => setVideoModalVisible(false)}
            footer={null}
            width={1000} 
            bodyStyle={{ padding: 0 }} 
          >
            {selectedVideo && (
              <video controls autoPlay style={{ width: '100%', height: 'auto', maxHeight: '80vh' }}>
                <source src={selectedVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </Modal>

          </div>
        </>
        </TabPane>  
      )}
      {((remarksData && remarksData.length > 0) || (evaluationRemarks && evaluationRemarks.length > 0)) && (evaluationStatus && (evaluationStatus === "Evaluated" || evaluationStatus === "Ask for resubmission")) && (
        <TabPane tab="Remarks" key="2" type="card">
        {remarksData ? (
          <List
            itemLayout="horizontal"
            dataSource={remarksData.slice().reverse()}
            renderItem={(remarkObj) => (
              <List.Item>
                 <List.Item.Meta
                avatar={<Avatar src={userLogo} />}
                title={
                  <div>
                    <span>{remarkObj.addedByName}</span>
                    <br />
                    <div className='remarks col-10 p-4 mt-2'>
                      <span>{remarkObj.remark}</span>
                    </div>                   
                  </div>
                }
              />
                <p className='mx-5'>{formatDate(remarkObj.addedOn)}</p>
            </List.Item>
            )}
          />
        ):(
          <List
            itemLayout="horizontal"
            dataSource={evaluationRemarks.slice().reverse()}
            renderItem={(remarkObj) => (
              <List.Item>
                 <List.Item.Meta
                avatar={<Avatar src={userLogo} />}
                title={
                  <div>
                    <span className='poppins-regular'>{remarkObj.addedByName}</span>
                    <br />
                    <div className='remarks col-10 p-4 mt-2 poppins-regular'>
                      <p className='mb-1' style={{color:'#111111'}}>
                        Feedback
                      </p>
                      <span className='text-midgrey' style={{fontSize:'12px'}}>{remarkObj.evaluationFeedback}</span>
                      <p className='mb-1 mt-3' style={{color:'#111111'}}>
                        Improvement
                      </p>
                      <span className='text-midgrey' style={{fontSize:'12px'}}>{remarkObj.evaluationImprovement}</span>
                    </div>                    
                  </div>
                }
              />
                <p className='mx-5 poppins-regular text-midgrey' style={{fontSize:'12px'}}>{formatDate(remarkObj.addedOn)}</p>
            </List.Item>
            )}
          />
        )}
        </TabPane>
      )}
      </Tabs>
    </Modal>
  );
};

export default ModalComponent;
